
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey } from '@/utils'
import { AppModule } from '@/store/modules/app'
import { getProductInfo } from '@/api/product/productAccount'
import { log } from 'console'

@Component({
  name: 'thaiExtraParam',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    status: null,
    frequency: 0,
    skip_queue: [],
    task: [],
    bill: 1,
    blocked_accounts: []
  }

  private task: any = [
    {
      account_type: '',
      frequency: 0
    }
  ]

  private payforQueueType: any = 'product'

  get language() {
    return AppModule.language
  }

  private rules: any = {
    frequency: [{ required: true, trigger: 'blur' }],
    account_type: [{ required: true, trigger: 'blur' }]
  }

  private change(e) {
    if (
      (e == 1 && this.extraParam.frequency === 0) ||
      this.extraParam.bill === 0
    ) {
      this.extraParam.frequency = 1
      this.extraParam.bill = 1
    }
  }

  private changeType(e) {
    if (e === 'account') {
      if (this.infoParams.extra_param.payfor_account_type_queue_config) {
        this.extraParam.status =
          this.infoParams.extra_param.payfor_account_type_queue_config.status
        this.task =
          this.infoParams.extra_param.payfor_account_type_queue_config.task
      }
    } else {
      if (this.infoParams.extra_param.payfor_queue_config) {
        this.extraParam.status =
          this.infoParams.extra_param.payfor_queue_config.status
        this.extraParam.frequency =
          this.infoParams.extra_param.payfor_queue_config.frequency
        this.extraParam.skip_queue =
          this.infoParams.extra_param.payfor_queue_config.skip_queue
        this.extraParam.bill =
          this.infoParams.extra_param.payfor_queue_config.bill
      }
      if (!this.infoParams.extra_param.payfor_queue_config.bill) {
        this.extraParam.bill = 1
      }
    }
    if (this.infoParams.extra_param.blocked_accounts) {
      this.extraParam.blocked_accounts =
        this.infoParams.extra_param.blocked_accounts
    }
  }

  private addBan() {
    // 确保数组存在
    if (!this.extraParam.blocked_accounts) {
      this.extraParam.blocked_accounts = ['']
    }
    this.extraParam.blocked_accounts.push('')
  }
  private removeBan(index: number) {
    this.extraParam.blocked_accounts.splice(index, 1)
  }

  private addAccountTypeQueue() {
    this.task.push({
      account_type: '',
      frequency: 0
    })
  }

  private remove(index: any) {
    this.task.splice(index, 1)
  }

  private numberChange(val) {
    this.extraParam.frequency = Number(val)
    this.$nextTick(() => {
      let num = Math.min(Number(val))
      if (num == 0) {
        this.extraParam.frequency = 1
      } else {
        this.extraParam.frequency = num
      }
    })
  }

  private numberBill(val) {
    this.extraParam.bill = Number(val)
    this.$nextTick(() => {
      let num = Math.min(Number(val))
      if (num == 0) {
        this.extraParam.bill = 1
      } else {
        this.extraParam.bill = num
      }
    })
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }
  private judge: boolean = false
  private changeAccountType(v: any) {
    if (v) {
      this.judge = false
    }
  }

  private async extraUpdate() {
    ;(this.$refs.extraParam as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          let data = {}
          if (this.payforQueueType === 'product') {
            data = {
              id: this.product.id,
              extra_param: {
                payfor_queue_type: this.payforQueueType,
                payfor_queue_config: {
                  status: this.extraParam.status,
                  frequency: Number(this.extraParam.frequency),
                  skip_queue: this.extraParam.skip_queue,
                  bill: this.extraParam.bill
                },
                blocked_accounts: this.extraParam.blocked_accounts
              }
            }
          }
          await setProductInfo(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message: 'Modified successfully!',
                type: 'success'
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private async extraUpdate1() {
    ;(this.$refs.extraParam as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.task = this.task.filter(item => item.account_type !== '')
        if (this.task.length > 0) {
          try {
            this.flag = true
            let data = {}
            data = {
              id: this.product.id,
              extra_param: {
                payfor_queue_type: this.payforQueueType,
                payfor_account_type_queue_config: {
                  status: this.extraParam.status,
                  task: this.task
                }
              }
            }
            await setProductInfo(data).then(() => {
              if (this.language === 'en') {
                this.$message({
                  message: 'Modified successfully!',
                  type: 'success'
                })
              }
              if (this.language === 'zh_cn') {
                this.$message({
                  message: '修改成功!',
                  type: 'success'
                })
              }
              if (this.language === 'zh_tw') {
                this.$message({
                  message: '修改成功!',
                  type: 'success'
                })
              }
              this.flagStr()
              this.back()
            })
          } catch (e) {
            this.flagStr()
          }
        } else {
          this.judge = true
          this.task = [
            {
              account_type: '',
              frequency: 0
            }
          ]
        }
      } else {
        return false
      }
    })
  }

  private async setBanAccount() {
    ;(this.$refs.extraParam as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        let data = {}
        data = {
          id: this.product.id,
          extra_param: {
            blocked_accounts: this.extraParam.blocked_accounts
          }
        }
        await setProductInfo(data).then(() => {
          if (this.language === 'en') {
            this.$message({
              message: 'Modified successfully!',
              type: 'success'
            })
          }
          if (this.language === 'zh_cn') {
            this.$message({
              message: '修改成功!',
              type: 'success'
            })
          }
          if (this.language === 'zh_tw') {
            this.$message({
              message: '修改成功!',
              type: 'success'
            })
          }
          this.flagStr()
          this.back()
        })
      } else {
        return false
      }
    })
  }

  private async shareSeve() {
    ;(this.$refs.extraParam as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.flag = true
        const data: any = {
          id: this.product.id,
          extra_param: {
            share_payout_account: this.extraParam.share_payout_account
          }
        }
        await setProductInfo(data).then(() => {
          if (this.language === 'en') {
            this.$message({
              message: 'Modified successfully!',
              type: 'success'
            })
          }
          if (this.language === 'zh_cn') {
            this.$message({
              message: '修改成功!',
              type: 'success'
            })
          }
          if (this.language === 'zh_tw') {
            this.$message({
              message: '修改成功!',
              type: 'success'
            })
          }
          this.flagStr()
          this.back()
        })
      } else {
        return false
      }
    })
  }

  private infoParams: any = {}
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      this.infoParams = res
      if (this.infoParams.extra_param.payfor_queue_type) {
        this.payforQueueType = this.infoParams.extra_param.payfor_queue_type
      } else {
        this.payforQueueType = 'product'
      }

      if (
        this.infoParams.extra_param.payfor_queue_type === 'product' &&
        this.infoParams.extra_param.payfor_queue_config
      ) {
        this.extraParam.status =
          this.infoParams.extra_param.payfor_queue_config.status
        this.extraParam.frequency =
          this.infoParams.extra_param.payfor_queue_config.frequency
        this.extraParam.skip_queue =
          this.infoParams.extra_param.payfor_queue_config.skip_queue
        this.extraParam.bill =
          this.infoParams.extra_param.payfor_queue_config.bill
      }

      if (
        this.infoParams.extra_param.payfor_queue_type === 'account' &&
        this.infoParams.extra_param.payfor_account_type_queue_config
      ) {
        this.extraParam.status =
          this.infoParams.extra_param.payfor_account_type_queue_config.status
        this.task =
          this.infoParams.extra_param.payfor_account_type_queue_config.task
      }
      this.extraParam.blocked_accounts =
        this.infoParams.extra_param.blocked_accounts
    })
  }

  mounted() {
    this.getInfo()
  }
}
